
import { useState, useEffect } from 'react';

export function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      title: "Global Energy Technology Partner",
      subtitle: "Integrating cutting-edge technology to empower the future of energy",
      description: "Leading upstream exploration solutions and cross-industry technology innovation",
      image: "https://public.readdy.ai/ai/img_res/80af7a302c623e61742faa21b8601194.jpg"
    },
    {
      title: "Innovation Engine for Upstream Exploration",
      subtitle: "Innovative solutions for the global oil and gas industry",
      description: "Maximizing exploration success rates through intelligent technology integration",
      image: "https://readdy.ai/api/search-image?query=Dynamic%203D%20seismic%20data%20visualization%20with%20AI%20neural%20network%20patterns%2C%20oil%20reservoir%20modeling%20graphics%2C%20deep%20blue%20and%20teal%20color%20scheme%2C%20professional%20geological%20survey%20atmosphere%2C%20flowing%20data%20particles%20and%20abstract%20code%20elements&width=1920&height=1080&seq=hero2&orientation=landscape"
    },
    {
      title: "Technology Bridge Across Industries",
      subtitle: "Connecting energy expertise with high-tech innovation",
      description: "Delivering proven solutions from complex industrial scenarios to diverse sectors",
      image: "https://readdy.ai/api/search-image?query=Advanced%20high-tech%20manufacturing%20facility%20with%20robotic%20automation%20systems%2C%20sophisticated%20industrial%20equipment%20and%20precision%20machinery%2C%20deep%20blue%20technology%20atmosphere%20with%20glowing%20digital%20interfaces%2C%20modern%20minimalist%20design%2C%20flowing%20data%20streams%20and%20AI-powered%20manufacturing%20processes%2C%20professional%20corporate%20environment&width=1920&height=1080&seq=hero3&orientation=landscape"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div 
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${slide.image})` }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent" />
        </div>
      ))}

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 text-left max-w-6xl">
        <div className="w-full">
          <div className="max-w-3xl">
            <h1 className="text-5xl md:text-7xl font-light text-white mb-6 leading-tight">
              {slides[currentSlide].title}
            </h1>
            <p className="text-xl md:text-2xl text-blue-200 mb-6 font-light">
              {slides[currentSlide].subtitle}
            </p>
            <p className="text-lg text-white/80 mb-12 leading-relaxed max-w-2xl">
              {slides[currentSlide].description}
            </p>
            
            <div className="flex flex-col sm:flex-row gap-6">
              <button 
                onClick={() => document.getElementById('solutions')?.scrollIntoView({ behavior: 'smooth' })}
                className="px-8 py-4 bg-blue-600 hover:bg-blue-7 text-white rounded-lg transition-all duration-300 font-medium whitespace-nowrap cursor-pointer"
              >
                Explore Solutions
              </button>
              <button 
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                className="px-8 py-4 border-2 border-white/30 hover:border-white text-white hover:bg-white/10 rounded-lg transition-all duration-300 font-medium whitespace-nowrap cursor-pointer"
              >
                Get In Touch
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-20">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
              index === currentSlide ? 'bg-white' : 'bg-white/40'
            }`}
          />
        ))}
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 right-8 text-white/60 animate-bounce">
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </section>
  );
}
